<template>
  <div class="eventos-etapas">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Evento">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="evento"
                :value="evento"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Etapas">

            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="etapas" 
                :fields="fields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaInicio)="data">
                {{ data.item.fechaInicio | fecha }}
              </template>
              <template v-slot:cell(fechaFin)="data">
                {{ data.item.fechaFin | fecha }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown 
                    v-if="agregarHabilitado & borrarHabilitado"
                    variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item 
                      v-if="agregarHabilitado & editarHabilitado"
                      @click.stop="editarItem(data.item)">
                    <i class="fa fa-edit"></i>Editar Datos de la Etapa</b-dropdown-item>
                  <b-dropdown-item 
                      v-if="agregarHabilitado & borrarHabilitado"
                      @click.stop="borrarItem(data.item)">
                    <i class="fa fa-remove"></i>Borrar Etapa</b-dropdown-item>
                </b-dropdown>
              </template>            
            </b-table>
            <!-- <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav> -->
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="agregarHabilitado"
              @click.stop="agregar">
            <i class="fa fa-plus"></i>Nueva Etapa</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoEtapas/getField',
  mutationType: 'eventoEtapas/updateField',
});

export default {
  name: 'EventosEtapasList',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      eventoId: 0,

      fields: [
        { 
          key: 'nombre',
          label: 'Nombre'
        },
        { key: 'fechaInicio' },
        { key: 'fechaFin' },
        { 
          key: 'participantes',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1,
      agregarHabilitado: false,
      editarHabilitado: false,
      borrarHabilitado: false
    }
  },
  computed: {
    ...mapFields([
      'cliente',
      'evento',

      'etapas',
      // 'paginaActual',
      // 'registrosPorPagina',
      // 'totalRegistros',
      // 'totalPaginas',
    ]),
  },
  created() {
    this.eventoId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
    }

    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.agregarHabilitado = true;
      this.editarHabilitado = true;
      this.borrarHabilitado = true;
    }

    this.showSpinner();
    this.$store.dispatch('eventoEtapas/inicializar', this.eventoId)
      .then(() => this.getItems())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('eventoEtapas/getEtapas')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    editarItem (item) {
      this.$router.push({ name: 'EventoEtapaEdit', 
                          params: { 
                            eventoId: this.eventoId, 
                            id: item.id 
                          }});
    },
    consultar (item) {
      this.$router.push({ name: 'EventoEtapaDatos', 
                          params: { 
                            eventoId: this.eventoId, 
                            id: item.id 
                          }});
    },
    agregar () {
      this.$router.push({ name: 'EventoEtapaAdd', 
                          params: { 
                            eventoId: this.eventoId
                          }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar la etapa selccionada?', 
            this.borrarEtapa.bind(this, item.id), 'Si', null, 'No')
    },
    borrarEtapa (eventoEtapaId) {
      let params = {
        eventoId: this.eventoId,
        eventoEtapaId
      }

      this.showSpinner();
      this.$store.dispatch('eventoEtapas/delete', params)
        .then(() => {
          this.showModalMsj('La etapa seleccionada se borró con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    goBack() {
      this.$router.push({ name: 'Eventos' }); 
      // this.$router.go(-1);
    }
  },
  watch: {
    // 'paginaActual' : function(newVal, oldVal) {
    //   if ( newVal != 0 && oldVal != 0) {
    //     this.getItems();
    //   }
    // },
  }    
}
</script>

<style>
</style>
